import React, { FC } from 'react'

type Props = {

}

export const Notification: FC<Props> = () => {
  const a = 1

  return (
    <> Notification... </>
  )
}
